import script from "./HomeRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeRoute.vue?vue&type=script&setup=true&lang=js"

import "./HomeRoute.vue?vue&type=style&index=0&id=894b7bbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-894b7bbc"]])

export default __exports__